module.exports = __webpack_public_path__ + "assets/fonts/6f81ce51-e9e2-4818-992f-e31b8212c6b7.b585dbb5.ttf";